import React from 'react';
import WidgetsFactory from './widgets-factory';
import WidgetTabsDesktop from '../widget-tabs/widget-tabs-desktop/widget-tabs-desktop';
import WidgetTabsTab from '../widget-tabs/widget-tabs-tab';
import WidgetTabsLabel from '../widget-tabs/widget-tabs-label';
import WidgetTabsContent from '../widget-tabs/widget-tabs-content';

import WidgetChipsDesktop from '../widget-chips/widget-chips-desktop/widget-chips-desktop';
import WidgetTextGridRegular from '../widget-text-grid-regular';
import WidgetImageTextDesktop from '../widget-image-text/widget-image-text';
import WidgetCategoryListDesktop from '../widget-category-list/widget-category-list-desktop';
import WidgetCategoryBlockDesktop from '../widget-category-block/widget-category-block';
import WidgetProductBoxDesktop from '../widget-product-box/widget-product-box';
import WidgetProductSliderDesktop from '../widget-product-slider/widget-product-slider-desktop';
import WidgetPhotosGridCircleDesktop from '../widget-photos-grid-circle/widget-photos-grid-circle-desktop';
import WidgetPhotosGridRegular from '../widget-photos-grid-regular';
import WidgetPhotosGridAdvanced from '../widget-photos-grid-advanced';
import WidgetCarouselDesktop from '../widget-carousel/widget-carousel-deskktop';
import WidgetPhotosGridBoxes from '../widget-photos-grid-boxes/widget-photos-grid-boxes';
import WidgetPhotosTeaserCircle from '../widget-photos-teaser-circle';
import WidgetPhotosGridTeaserDesktop from 'modules/shared/widgets/components/widget-photos-grid-teaser/widget-photos-grid-teaser-desktop';
import WidgetPhotosGridTeaserManualDesktop from 'modules/shared/widgets/components/widget-photos-grid-teaser-manual/widget-photos-grid-teaser-manual-desktop';
import WidgetRecommendationsDesktop from '../widget-recommendations/widget-recommendations-desktop';
import WidgetBannerSliderDesktop from 'modules/shared/widgets/components/widget-banner-slider/widget-banner-slider-desktop';
import WidgetOpening from 'modules/shared/widgets/components/widget-opening';

import { WidgetsFactoryInterface } from './widgets-factory.interfaces';

const widgets = {
    WidgetTabs: WidgetTabsDesktop,
    WidgetTabsTab,
    WidgetTabsLabel,
    WidgetTabsContent,
    WidgetChips: WidgetChipsDesktop,
    WidgetCarousel: WidgetCarouselDesktop,
    WidgetCategoryList: WidgetCategoryListDesktop,
    WidgetCategoryBlock: WidgetCategoryBlockDesktop,
    WidgetProductBox: WidgetProductBoxDesktop,
    WidgetProductSlider: WidgetProductSliderDesktop,
    WidgetPhotosGridCircle: WidgetPhotosGridCircleDesktop,
    WidgetPhotosGridRegular,
    WidgetPhotosGridAdvanced,
    WidgetTextGridRegular,
    WidgetImageText: WidgetImageTextDesktop,
    WidgetPhotosGridBoxes,
    WidgetPhotosGridTeaserCircle: WidgetPhotosTeaserCircle,
    WidgetPhotosGridTeaser: WidgetPhotosGridTeaserDesktop,
    WidgetPhotosGridTeaserManual: WidgetPhotosGridTeaserManualDesktop,
    WidgetRecommendations: WidgetRecommendationsDesktop,
    WidgetBannerSlider: WidgetBannerSliderDesktop,
    WidgetOpening
};

const WidgetFactoryDesktop: React.FC<{ config: WidgetsFactoryInterface[]; }> = ({ config }) => (
    <WidgetsFactory config={config} widgets={widgets} />
);

export default WidgetFactoryDesktop;
